import {
  Component,
  OnDestroy,
  Input,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { MapState } from '../map/map.states';
import { MapActions } from '../map/map.actions';
import { statesHandler, MAPMODE, DRAWINGSTATE } from '../map/map-state-control';
import { Field } from '../fields/field.model';
import { ProcessProgressState } from './process-progress.states';
import { ProcessProgressActions } from './process-progress.actions';
import {
  selectProcessLabel,
  selectDrawingState,
  selectProcessMode,
  selectStepCounter,
} from './process-progress.selector';
import { selectCurMapMode } from '../map/map.selector';

@Component({
    selector: 'app-process-progress',
    templateUrl: './process-progress.component.html',
    styleUrls: ['./process-progress.component.scss'],
    standalone: false
})
export class ProcessProgressComponent implements OnDestroy {
  @Input() selField: Field | undefined;

  // local mapping to access the types in the html for better readability of the checks
  lMAPMODES = MAPMODE;
  lDRAWINGSTATES = DRAWINGSTATE;

  stateSub: Subscription;
  curStates: statesHandler;

  processSteps: ProcessStep[] = [];
  curProcessStep: number = 0;

  label$: Observable<String>;
  drawingState$: Observable<DRAWINGSTATE>;
  processMode$: Observable<MAPMODE>;

  constructor(
    public translate: TranslateService,
    private store: Store<{
      mapdata: MapState;
      process: ProcessProgressState;
    }>
  ) {
    this.label$ = this.store.select('process').pipe(select(selectProcessLabel));
    this.drawingState$ = this.store
      .select('process')
      .pipe(select(selectDrawingState));
    this.processMode$ = this.store
      .select('process')
      .pipe(select(selectProcessMode));

    this.store.select('mapdata').pipe(select(selectCurMapMode)).subscribe((newMapMode) => {
      // Update the number of process steps based on current map mode
      switch (newMapMode) {
        case MAPMODE.FIELDCREATION:
        case MAPMODE.FIELDEDITING:
        case MAPMODE.SCENARIOCREATION:
          this.processSteps = [{ id: 0 }, { id: 1 }];
          break;
        case MAPMODE.EASYTRAMPLANNING:
          this.processSteps = [{ id: 0 }, { id: 1 }, { id: 2 }, { id: 3 }];
          break;
        default:
          this.processSteps = [];
      }
    });

    this.store.select('process').pipe(select(selectStepCounter)).subscribe((newStepCounter) => {
      this.curProcessStep = newStepCounter;
    });

    this.curStates = {
      mapMode: MAPMODE.DEFAULT,
      drawingState: DRAWINGSTATE.UNFINISHED,
      nameValid: false,
    };

    this.stateSub = this.store.select('mapdata').subscribe((newData) => {
      this.curStates = {
        mapMode: newData.mapMode,
        drawingState: newData.drawingState,
        nameValid: newData.nameValid,
        nextStateReady: this.nextTransitionReady(newData),
      };
    });
  }

  ngOnDestroy(): void {
    this.stateSub.unsubscribe();
  }

  backBtnClicked() {
    // this.store.dispatch(MapActions.undo());
    this.store.dispatch(ProcessProgressActions.requestStepBack());
  }

  cancelBtnClicked() {
    this.store.dispatch(ProcessProgressActions.cancelProcess());
  }

  nextBtnClicked() {
    this.store.dispatch(ProcessProgressActions.requestNextStep());
  }

  saveBtnClicked() {
    // this.store.dispatch(
    //   ProcessProgressActions.finishProcess({ assignedName: '' })
    // );
  }

  nextTransitionReady(newData: MapState): boolean {
    // Determine if the next transition is ready based on current map and process state
    switch (newData.mapMode) {
      case MAPMODE.FIELDCREATION:
      case MAPMODE.FIELDEDITING:
        return newData.drawingState === DRAWINGSTATE.FINISHED;
      case MAPMODE.SCENARIOCREATION:
        return true;
      case MAPMODE.EASYTRAMPLANNING:
        return newData.easyTramPlan?.currentStateValidForNextStep() || false;
      default:
        return false;
    }
  }
}

interface ProcessStep {
  id: number;
}